import { Button, message, Modal, Space, Table } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import service from '../../../@services'
import AuthComponent from '../../../components/AuthComponent'
/**
 *
 * @param {Array} list 表格数据
 * @param {String|Number} total 数据总条数
 * @param {Object} page pageIndex:页码 pageSize:页面大小
 * @param {Function} submit 切换页码时的方法
 * @param {Boolean} loading 数据是否加载中
 * @returns
 */
const PaymentListTable = ({ list, total, page, submit, loading } = {}) => {
  const columns = [
    {
      title: '供应门店',
      dataIndex: 'storeName',
      key: 'storeName',
      align: 'center',
      render: (text, record) => `[${record.storeCode}]${text}`,
    },
    {
      title: '缴款单单号',
      dataIndex: 'payinSlipNo',
      key: 'payinSlipNo',
      align: 'center',
    },
    {
      title: '销售发生日期',
      dataIndex: 'tradeDate',
      key: 'tradeDate',
      align: 'center',
    },
    {
      title: '缴款单生成日期',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
    },
    {
      title: '收银机编码',
      dataIndex: 'posId',
      key: 'posId',
      align: 'center',
    },
    {
      title: '收银员',
      dataIndex: 'employeeName',
      key: 'employeeName',
      align: 'center',
      render: (text, record) => `[${record.employeeCode}]${text}`,
    },
    {
      title: '缴款类型',
      dataIndex: 'payTypeName',
      key: 'payTypeName',
      align: 'center',
    },
    {
      title: '缴款金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
    },
    {
      title: '审核人',
      dataIndex: 'verifierName',
      key: 'verifierName',
      align: 'center',
    },
    {
      title: '审核时间',
      dataIndex: 'verifyTime',
      key: 'verifyTime',
      align: 'center',
    },
    {
      title: '审核标识',
      dataIndex: 'statusName',
      key: 'statusName',
      align: 'center',
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        record.statusCode === 0 && (
          <Space>
            <AuthComponent authKey="/payin/payin-slip/item/verify">
              <Button type="link" onClick={() => handleAudit(record)}>
                审核
              </Button>
            </AuthComponent>
            <AuthComponent authKey="/payin/payin-slip/item/reject">
              <Button type="link" onClick={() => handleReject(record)}>
                驳回申请
              </Button>
            </AuthComponent>
          </Space>
        ),
    },
  ]
  const handleAudit = (record) => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: `确定 审核 缴款单号:【${record.payinSlipNo}】- 缴款类型:【${record.payTypeName}】吗？`,
      okText: '确认',
      cancelText: '取消',
      onOk() {
        return service.order.verifyPayinSlip({ id: record.id }).then((res) => {
          message.success('操作成功！')
          submit()
        })
      },
      onCancel() {},
    })
  }
  const handleReject = (record) => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: `确定 驳回 缴款单号:【${record.payinSlipNo}】- 缴款类型:【${record.payTypeName}】吗？`,
      okText: '确认',
      cancelText: '取消',
      onOk() {
        return service.order.rejectPayinSlip({ id: record.id }).then((res) => {
          message.success('操作成功！')
          submit()
        })
      },
      onCancel() {},
    })
  }
  return (
    <Table
      size="middle"
      loading={loading}
      bordered
      columns={columns}
      dataSource={list}
      rowKey="payinSlipNo"
      pagination={{
        showQuickJumper: true,
        showSizeChanger: true,
        pageSize: page.pageSize,
        current: page.pageIndex,
        total,
        showTotal: (total) => `当前条件共检索到 ${total} 条信息`,
        onChange: (pageIndex, pageSize) => submit({ pageIndex, pageSize }),
      }}
    />
  )
}

export default PaymentListTable
